export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';
export const parentWindow = { domain: 'http://localhost:8080', cellcaptiveId: null };
export const SCROLL_TOP = 'SCROLL_TOP';
export const RESIZE = 'RESIZE';
export const RAVEN_LOG_LEVEL = { level: 'info' }  // one of 'info', 'warning', or 'error'
  



// WEBPACK FOOTER //
// ./app/utils/constants.js